<template>
  <div>
    <p style="text-align: center">
      <img :src="appLogo" style="width: 190px" />
    </p>
    <p style="text-align: center">
      <strong
        ><span
          style="font-size: 20px; font-family: Arial, Helvetica, sans-serif"
          >Re&ccedil;ue de r&egrave;glement
        </span></strong
      >
    </p>
    <p>
      <span style="font-family: Arial, Helvetica, sans-serif"
        ><strong>Date : {{ date() }}</strong></span
      >
    </p>
    <p>
      <span style="font-family: Arial, Helvetica, sans-serif"
        >je soussigné(e) Mr/Mme : {{ name }}</span
      >
    </p>
    <p>
      <span style="font-family: Arial, Helvetica, sans-serif"
        >Certifie avoir reçue la somme de {{ total }} TND sur l&apos;article
        {{ article }}</span
      >
    </p>
    <p>
      <span style="font-family: Arial, Helvetica, sans-serif"><br /></span>
    </p>
    <p style="text-align: center">
      <span style="font-family: Arial, Helvetica, sans-serif"
        >Signature Déposant &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Tampon
      </span>
    </p>
    <p>
      <span style="font-family: Arial, Helvetica, sans-serif">&nbsp; </span>
    </p>
  </div>
</template>
<script>
import { Printd } from "printd";
import contants from "@/mixins/constants";
export default {
  mixins: [contants],
  props: {
    name: {
      type: String,
      default: "",
    },
    article: {
      type: String,
      default: "",
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    date: function () {
      const date = new Date();
      const month = date.getMonth() + 1;
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      return (
        (dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth) +
        "/" +
        (month < 10 ? "0" + month : month) +
        "/" +
        year
      );
    },
    printMe() {
      const d = new Printd();
      d.print(this.$el, [
        `
        table {
    border:solid #000 !important;
    border-width:1px 0 0 1px !important;
}
th, td {
    border:solid #000 !important;
    border-width:0 1px 1px 0 !important;
}
      `,
      ]);
    },
  },
};
</script>
